<template>
    <div class="order-copy pop_white-s pop_bege popup_wrap" style="display:block">
        <div class="popup_in">
            <div class="popup">
                <div class="popup_close stay_close close-animate">
                    <a href="javascript:void(0);" @click.prevent="closePop">
                        <close />
                    </a>
                </div>
                <div class="corner-top"></div>
                <div class="exists_icon">
                    <LOGO />
                </div>
                <div class="pop_frame">
                    <h2 class="title25" style="margin-top:20px;">הזמנה קבועה במצב מוקפא</h2>
                    <div class="text">
                      היי, ההזמנה הקבועה שלך במצב "מוקפא".
                      <br>
                      על מנת שנוכל לשלוח לך אותה יש להעביר למצב "פעיל"
                    </div>

                    <div class="bt_green ease">
                        <a href="javascript:void(0);" @click.prevent="closePop">הבנתי , תודה</a>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import close from "../../assets/img/close.svg";
    import LOGO from "../../assets/img/carmella.svg";
    export default {
        name: "PerOrderSent",
        methods: {
            goToPermOrderPage() {
                this.closePop();
                this.$root.$emit('editPermOrder',{editOrder: true});
                //this.$router.push({name: 'permenent'});
            },
            goTohistory(){
                this.$router.push({path: '/my-account/history'})
              this.closePop();
            },
            closePop() {
                this.$emit('close');

            }
        },
        components:{
            LOGO,
            close
        }
    }
</script>

<style scoped>
    .bt_green a{
        width: 100%;
    }
</style>
